<template>
	<div class="more_menu-mobile" :class="{ open: Boolean(route.query.isMoreMenuOpen) && !displayStore.isDesktop }">
		<MobileSubHeader />
		<MarketTimingLayout class="c_responsive market-timing-layout">
			<div class="input-layout">
				<InputSearch
					:model-value="searchValue"
					:is-left="true"
					:class="{ active_search: searchValue.length > 0 }"
					:placeholder="PLACEHOLDER_SEARCH_TITLE"
					@update:model-value="onInputSearch"
					><SearchDropDown
						v-if="searchValue.length !== 0"
						:data="eventSearchData?.search_result ?? []"
						class="search_dropdown"
						@close="onClickSearchList"
				/></InputSearch>
			</div>
			<ListLayout>
				<UserCard @close="onClickMenu" />
				<MenuGridBox @close="onClickMenu" />
			</ListLayout>
			<MoreMainMenuList @close="onClickMenu" />
		</MarketTimingLayout>
	</div>
</template>

<script setup lang="ts">
// component
import { onUnmounted } from 'vue';
import { computed, ref } from 'vue';
// core
import { useRoute } from 'vue-router';
import { debounce } from 'lodash';

import { useGetEventSearchApi } from '@/api/event';
import SearchDropDown from '@/components/atom/dropdown/SearchDropDown.vue';
import MobileSubHeader from '@/components/layout/header/MobileSubHeader.vue';
import MenuGridBox from '@/components/layout/header/MoreMenu/MenuGridBox.vue';
import MoreMainMenuList from '@/components/layout/header/MoreMenu/MoreMainMenuList.vue';
import UserCard from '@/components/layout/header/MoreMenu/UserCard.vue';
import ListLayout from '@/components/layout/main/ListLayout.vue';
import MarketTimingLayout from '@/components/layout/main/MarketTimingLayout.vue';
import { PLACEHOLDER_SEARCH_TITLE } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();
const searchValue = ref('');

const { data: eventSearchData } = useGetEventSearchApi(
	computed(() => ({ search: searchValue.value })),
	computed(() => !!searchValue.value),
	true // 통합검색
);
const onInputSearch = debounce(
	async (val: string) => {
		searchValue.value = val;
	},
	200,
	{ leading: false }
);
const onClickMenu = () => {
	document.body.classList.remove('hidden');
};

const onClickSearchList = () => {
	searchValue.value = '';
};

onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.more_menu-mobile {
	position: fixed;
	float: right;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background-color: var(--color-bg);
	box-shadow: 0.4rem 0.4rem 1.5rem 0rem #5a5a5a;
	&::-webkit-scrollbar {
		display: none;
	}
	overflow-y: auto;
	color: var(--color-base-white);
	.market-timing-layout {
		padding: 3.3rem 2rem;
		.input-layout {
			position: relative;
			.search_dropdown {
				position: absolute;
				top: 4.8rem;
				background: var(--color-bg);
				z-index: 10;
				border: 1px solid var(--color-primary);
				border-radius: 0rem 0rem 0.8rem 0.8rem;
				overflow: hidden;
			}
		}
	}
}
</style>
